import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const userActivityApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/user-activities`, { params });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default userActivityApi;
